import { useState } from "react";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { staffLogin } from "@/lib/api";
import { Input } from "@/components/ui/input";

const fmt = (d) => (Array.isArray(d) ? d.map((x) => x?.msg || JSON.stringify(x)).join(" ") : typeof d === "string" ? d : "Something went wrong");

export const StaffLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { onSuccess(await staffLogin(email.trim(), password)); }
    catch (err) { setError(fmt(err?.response?.data?.detail) || err.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F0] grain flex items-center justify-center p-6" data-testid="staff-login">
      <form onSubmit={submit} className="w-full max-w-sm bg-white/[0.04] border border-white/10 rounded-2xl p-7 space-y-5">
        <div className="flex items-center gap-3">
          <img src="/brand/logo.jpg" alt="" className="w-12 h-12 rounded-xl bg-white p-1 object-contain" />
          <div><p className="overline text-[#93C5FD]">Echo · Staff</p><h1 className="font-serif text-2xl leading-tight">Sign in to Admin</h1></div>
        </div>
        <label className="block"><span className="overline text-white/50">Email</span><Input data-testid="login-email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 h-12 bg-white/5 border-white/15 text-white" required /></label>
        <label className="block"><span className="overline text-white/50">Password</span><Input data-testid="login-password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 h-12 bg-white/5 border-white/15 text-white" required /></label>
        {error && <p data-testid="login-error" className="text-sm text-[#93C5FD] bg-[#2563EB]/15 border border-[#2563EB]/30 rounded-lg px-3 py-2">{error}</p>}
        <button data-testid="login-submit" disabled={busy} className="w-full h-12 rounded-full bg-[#F5F5F0] text-[#001A4D] font-medium flex items-center justify-center gap-2 disabled:opacity-60">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />} Sign in
        </button>
        <Link to="/" className="flex items-center justify-center gap-1 text-xs text-white/40 hover:text-white/70"><ArrowLeft className="w-3 h-3" /> Back to Echo</Link>
      </form>
    </div>
  );
};
